import React, { memo, useEffect, useMemo } from 'react';
import { Conversation, useChatChatter } from '../../../../redux/services/nebulaChat';
import { useTypedDispatch, useTypedSelector } from '../../../../redux/hooks';
import { selectAuthUserByUuid, setViewContact } from '../../../../redux/slices';
import { useUserStatusContext } from '../../../../pages/home/children/UserStatusContext';
import EntityIcon, { GropDisplayUser } from '../../../icons/EntityIcon';
import { selectChatMembersOnChat } from '../../../../redux/slices/chatNSlice';

interface ChatIconProps {
    convo: Conversation;
    splitGroup?: boolean;
    size?: number;
}

export const ChatIconUser: React.FC<{ uuid: string, size: number }> = memo(({ uuid, size }) => {
    const chatter = useChatChatter({ userUuid: uuid });

    const foundUser = useTypedSelector(state => selectAuthUserByUuid(state, uuid));

    const { addNameForReq } = useUserStatusContext();

    const dispatch = useTypedDispatch();

    useEffect(() => {
        const returnFunc = () => {
            if (chatter.sip_name) {
                addNameForReq(chatter.sip_name, false)
            }
        }

        if (!chatter.sip_name) return returnFunc;

        addNameForReq(chatter.sip_name, true)
        return returnFunc;
    }, []);

    if (chatter.is_integration) {
        return <EntityIcon type='phonebook' details={
            { uuid: chatter.uuid }
        } />
    }

    return <EntityIcon
        type='user'
        details={{
            sip_name: chatter.sip_name,
            display_name: chatter.name,
            avatar_key: chatter.file_key,
            blf: !!chatter.sip_name,
            uuid
        }}
        size={size}
        onClick={() => {
            if (foundUser) {
                dispatch(setViewContact(foundUser))
            }
        }}
    />
});

const ChatIconGroup: React.FC<{ chat: Conversation, size: number, splitGroup?: boolean }> = ({ chat, size, splitGroup }) => {
    const participants = useTypedSelector(state => selectChatMembersOnChat(state, chat.uuid)) || [];

    const displayUsers = useMemo(() => {
        const details: GropDisplayUser[] = []

        for (let i = 0; i < Math.min(participants.length, 2); i += 1) {
            const foundUser = participants[i];

            if (foundUser) {
                details.push({
                    avatar_key: undefined,
                    nickname: "Unknown User",
                    uuid: foundUser.member
                })
            }
        }
        return details
    }, [participants.length]);

    return (
        <EntityIcon
            type='chat_group'
            details={{
                uuid: chat.uuid,
                display_users: displayUsers,
                avatar_set: splitGroup ? false : chat.avatar_set
            }}
            size={size}
            allowDrag={false}
        />
    )
}

export const ConversationIcon: React.FC<ChatIconProps> = memo(({ convo, splitGroup, size = 40 }) => {

    if (convo?.type === 'user') {
        return <ChatIconUser
            uuid={convo.uuid}
            size={size}
        />
    }

    // if (chat.integration?.channel.toLowerCase() === 'sms') {
    if (convo.type === 'integration') {
        return <EntityIcon
            type='phonebook'
            details={{ uuid: convo.uuid }}
            size={size}
            allowDrag={false}
        />
    }

    if (convo.type === 'channel') {
        return <ChatIconGroup
            chat={convo}
            size={size}
            splitGroup={splitGroup}
        />
    }

    return <></>
})
